var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseSheet',_vm._g(_vm._b({staticClass:"cosmo-front-office-board",class:{
    'title-board': /^title$/.test(_vm.type),
    'pa-4': _vm.isPaddingNeeded,
    'pa-0': _vm.paddingSimple,
  }},'BaseSheet',_vm.$attrs,false),_vm.$listeners),[_vm._t("header"),_c('div',{class:{ 'mt-6': _vm.$slots.header, 'mb-6': _vm.$slots.footer }},[_vm._t("default")],2),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }